import { LAUNCH_PANEL_PATH, SESSIONS_PATH } from '../../../../api/paths';
import { THIRTY_MINS_IN_SECONDS } from '../../../../utils/constants';
import { dcloudApi } from '../../../api';
import { TAGS } from '../../../api/constants';

export const launchPanelApi = dcloudApi.injectEndpoints({
  endpoints: (build) => ({
    getLaunchPanel: build.query<LaunchPanelResponse, FetchLaunchPanelArgs>({
      keepUnusedDataFor: THIRTY_MINS_IN_SECONDS,
      providesTags: [TAGS.LAUNCH_PANEL],
      query: ({ sessionUid, versionUid }) => ({
        method: 'get',
        suppressErrorToast: true,
        url: `${SESSIONS_PATH}/${sessionUid}/${LAUNCH_PANEL_PATH}?versionUid=${versionUid}`,
      }),
    }),
  }),
});

export const { useGetLaunchPanelQuery } = launchPanelApi;
